import { render, staticRenderFns } from "./ActionPremiumChat.vue?vue&type=template&id=1330ad71&scoped=true&"
import script from "./ActionPremiumChat.vue?vue&type=script&lang=js&"
export * from "./ActionPremiumChat.vue?vue&type=script&lang=js&"
import style0 from "./ActionPremiumChat.vue?vue&type=style&index=0&id=1330ad71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1330ad71",
  null
  
)

export default component.exports